(function () {
  var KEY = 'cedar-artists-v1';
  var TTL = 60 * 60 * 1000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function sortKey(name) {
    return name.toLowerCase().replace(/\$/g, 's').replace(/[^a-z0-9]/g, '');
  }

  function fetchAll() {
    var out = [];
    function page(n) {
      return fetch(root + 'collections/vocal-preset/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var items = j.products || [];
          out = out.concat(items);
          return items.length === 250 ? page(n + 1) : out;
        });
    }
    return page(1);
  }

  function load() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(KEY));
      if (cached && Date.now() - cached.t < TTL) return Promise.resolve(cached.d);
    } catch (e) {}
    return fetchAll().then(function (all) {
      var data = all
        .filter(function (p) { return p.product_type === 'Vocal Preset' && !/^free /i.test(p.title); })
        .map(function (p) { return { n: p.title.replace(/\s*vocal preset$/i, ''), h: p.handle }; })
        .sort(function (a, b) { return sortKey(a.n) < sortKey(b.n) ? -1 : 1; });
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
      return data;
    });
  }

  function render(box, data) {
    var list = box.querySelector('[data-artist-list]');
    var groups = {};
    var order = [];
    data.forEach(function (a) {
      var k = sortKey(a.n);
      var l = /^[a-z]/.test(k) ? k.charAt(0).toUpperCase() : '#';
      if (!groups[l]) { groups[l] = []; order.push(l); }
      groups[l].push(a);
    });
    order.sort(function (a, b) { return a === '#' ? -1 : b === '#' ? 1 : a < b ? -1 : 1; });
    var html = '';
    order.forEach(function (l) {
      html += '<div class="cedar-artists__group" data-letter><p class="cedar-artists__letter">' + l + '</p><ul class="list-unstyled" role="list">';
      groups[l].forEach(function (a) {
        var safe = a.n.replace(/&/g, '&amp;').replace(/</g, '&lt;');
        html += '<li data-key="' + sortKey(a.n) + '"><a class="cedar-artists__link link" href="' + root + 'products/' + a.h + '">' + safe + '</a></li>';
      });
      html += '</ul></div>';
    });
    list.innerHTML = html;
    box.classList.add('is-ready');
  }

  function bindSearch(box) {
    var input = box.querySelector('[data-artist-search]');
    var empty = box.querySelector('[data-artist-empty]');
    if (!input) return;
    input.addEventListener('input', function () {
      var q = sortKey(input.value);
      var shown = 0;
      box.querySelectorAll('[data-letter]').forEach(function (g) {
        var any = false;
        g.querySelectorAll('li').forEach(function (li) {
          var ok = !q || li.getAttribute('data-key').indexOf(q) !== -1;
          li.hidden = !ok;
          if (ok) { any = true; shown++; }
        });
        g.hidden = !any;
      });
      if (empty) empty.hidden = shown > 0;
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') input.value = ''; });
  }

  function init() {
    var boxes = document.querySelectorAll('[data-cedar-artists]');
    if (!boxes.length) return;
    boxes.forEach(bindSearch);
    load().then(function (data) {
      boxes.forEach(function (b) { render(b, data); });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
